// Listen for clicks on "Add to Cart" buttons
$(document).ready(function () {
  $('.11za-addtoCart').click(async function () {
    const cookiee = getCookie('refkey');
    var productId = $(this).attr('11za-product-id');
    var productName = $(this).attr('11za-product-name');
    var data = {
      refkey: cookiee,
      event: "addtocart",
      details: {
        items: [{
          title:productName,
          product_id:productId,
        }]
      }
    };
    sendDataToAPI(data);
  });
});


// Function to send data to your API using AJAX
function sendDataToAPI(data) {
  console.log('sendDataToAPI', data)
  $.ajax({
    url: "https://app.11za.in/shopifyref",
    type: 'POST',
    dataType: "json",
    contentType: "application/x-www-form-urlencoded",
    data: data,
    success: function (response) {
      console.log("Data sent successfully:", response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error("Error sending data:", errorThrown);
    },
  });
}


function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const cookieParts = cookie.split('=');
    if (cookieParts[0] === name) {
      return decodeURIComponent(cookieParts[1]);
    }
  }
  return null;
}

// Function to get the value of the refkey from the URL
function getRefkeyFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("refkey");
}

// Function to set a cookie with the refkey
function setRefkeyCookie(refkey) {
  // Calculate the expiration date 30 days from the current date
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);

  // Format the expiration date in the correct GMT format
  const formattedExpirationDate = expirationDate.toGMTString();

  // Set the cookie with the updated expiration date
  document.cookie = `refkey=${refkey}; expires=${formattedExpirationDate}; path=/`;
}


// Check if refkey is present in the URL
const refkey = getRefkeyFromURL();
if (refkey) {
  setRefkeyCookie(refkey);
}
